import { getNestConfig } from '../../utilities/config';

export const useUpdateFirebase = () => {
  const { nestApi } = getNestConfig();

  const updateFirebaseUserEmail = async ({
    newEmail,
    firebaseToken,
  }: {
    newEmail: string;
    firebaseToken: string;
  }) => {
    const response = await fetch(
      `${nestApi}/firebase/update-firebase-user-email`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${firebaseToken}`,
        },
        mode: 'cors',
        body: JSON.stringify({ newEmail }),
      },
    );

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return response.json();
  };

  const updateFirebaseUserPassword = async ({
    newPassword,
    firebaseToken,
  }: {
    newPassword: string;
    firebaseToken: string;
  }) => {
    const response = await fetch(
      `${nestApi}/firebase/update-firebase-user-password`,
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${firebaseToken}`,
        },
        body: JSON.stringify({
          newPassword: newPassword,
        }),
      },
    );

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return response.json();
  };

  const updateFirebaseUserData = async ({
    firstname,
    lastname,
    firebaseToken,
  }: {
    firstname: string;
    lastname: string;
    firebaseToken: string;
  }) => {
    const response = await fetch(
      `${nestApi}/firebase/update-firebase-user-profile`,
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${firebaseToken}`,
        },
        body: JSON.stringify({
          firstname,
          lastname,
        }),
      },
    );

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return response.json();
  };

  return {
    updateFirebaseUserEmail,
    updateFirebaseUserPassword,
    updateFirebaseUserData,
  };
};
